import { useEffect, useState } from "react";
import QRCode from "qrcode";
import { toast } from "sonner";
import { Download, Printer, Copy, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";

const URL_ = `${window.location.origin}/event`;

function printQr(dataUrl) {
  const w = window.open("", "_blank");
  if (!w) { toast.error("Allow pop-ups to print"); return; }
  w.document.write(`<html><head><title>Food Bazaar - Guest Portal QR</title></head><body style="font-family:sans-serif;text-align:center;padding:40px">
    <h1 style="font-size:48px;margin:0">FOOD BAZAAR</h1><h2 style="font-size:28px;margin:8px 0 24px">Vote for your favorites &middot; Recharge your drinks</h2>
    <img src="${dataUrl}" style="width:420px;height:420px"/><p style="font-size:20px">Scan with your phone camera</p>
    <p style="font-size:14px;color:#555">${URL_}</p><script>window.onload=()=>{window.print()}</script></body></html>`);
  w.document.close();
}

export default function RechargeQR() {
  const [dataUrl, setDataUrl] = useState(null);
  useEffect(() => { QRCode.toDataURL(URL_, { width: 1024, margin: 2, errorCorrectionLevel: "M" }).then(setDataUrl); }, []);

  const download = () => { const a = document.createElement("a"); a.href = dataUrl; a.download = "food-bazaar-guest-portal-qr.png"; a.click(); };
  const copy = async () => { try { await navigator.clipboard.writeText(URL_); toast.success("Link copied"); } catch (e) { toast.error("Copy failed"); } };

  return (
    <div className="space-y-6" data-testid="recharge-qr-page">
      <div>
        <div className="text-xs tracking-[0.3em] uppercase text-orange-400 font-bold">Guest Self-Service</div>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black text-white tracking-tight">GUEST PORTAL QR</h1>
        <p className="text-slate-400 mt-2 max-w-xl text-sm">Display this one code around the event. It opens the guest portal, where guests can vote for their favorites or recharge their drinks by card after scanning their ticket barcode. Employee tickets can't be recharged.</p>
      </div>
      <div className="grid md:grid-cols-[auto_1fr] gap-6 items-start">
        <div className="bg-white rounded-2xl p-4 w-full max-w-[320px]">
          {dataUrl && <img src={dataUrl} alt="Recharge QR code" className="w-full" data-testid="recharge-qr-image" />}
        </div>
        <div className="bg-[#131D33] border border-slate-800 rounded-2xl p-5 space-y-4">
          <div>
            <div className="text-[10px] uppercase tracking-widest text-slate-500">Public link</div>
            <div className="font-mono-fb text-orange-300 break-all" data-testid="recharge-qr-url">{URL_}</div>
          </div>
          <div className="flex flex-wrap gap-2">
            <Button onClick={download} disabled={!dataUrl} className="bg-orange-500 hover:bg-orange-600 text-white" data-testid="recharge-qr-download"><Download size={16} className="mr-1" /> Download PNG</Button>
            <Button onClick={() => printQr(dataUrl)} disabled={!dataUrl} variant="outline" className="bg-slate-900 border-slate-700" data-testid="recharge-qr-print"><Printer size={16} className="mr-1" /> Print</Button>
            <Button onClick={copy} variant="outline" className="bg-slate-900 border-slate-700" data-testid="recharge-qr-copy"><Copy size={16} className="mr-1" /> Copy link</Button>
            <a href={URL_} target="_blank" rel="noreferrer"><Button variant="outline" className="bg-slate-900 border-slate-700" data-testid="recharge-qr-open"><ExternalLink size={16} className="mr-1" /> Open page</Button></a>
          </div>
        </div>
      </div>
    </div>
  );
}
